export default __webpack_public_path__ + "static/media/fedora.94745155.svg";